import { render, staticRenderFns } from "./ImportEmploymentFailed.vue?vue&type=template&id=0e0b08b1"
import script from "./ImportEmploymentFailed.vue?vue&type=script&lang=js"
export * from "./ImportEmploymentFailed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports